import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MatMomentDateModule } from '@angular/material-moment-adapter';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		MatToolbarModule,
		MatButtonModule,
		MatCardModule,
		MatInputModule,
		MatDialogModule,
		MatTableModule,
		MatMenuModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatPaginatorModule,
		MatSortModule,
		MatSelectModule,
		MatCheckboxModule,
		MatFormFieldModule,
		MatRippleModule,
		MatExpansionModule,
		MatSlideToggleModule,
		MatChipsModule,
		MatBadgeModule,
		MatButtonToggleModule,
		MatTooltipModule,
		MatSnackBarModule,
		MatSidenavModule,
		MatStepperModule,
		MatAutocompleteModule,
		MatTabsModule,
		MatDividerModule,
		MatListModule,
		MatAutocompleteModule,
		MatFormFieldModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatMomentDateModule,
		MatTreeModule,
	],
	exports: [
		CommonModule,
		MatToolbarModule,
		MatButtonModule,
		MatCardModule,
		MatInputModule,
		MatDialogModule,
		MatTableModule,
		MatMenuModule,
		MatIconModule,
		MatProgressSpinnerModule,
		MatProgressBarModule,
		MatPaginatorModule,
		MatSortModule,
		MatSelectModule,
		MatCheckboxModule,
		MatFormFieldModule,
		MatRippleModule,
		MatExpansionModule,
		MatSlideToggleModule,
		MatChipsModule,
		MatBadgeModule,
		MatButtonToggleModule,
		MatTooltipModule,
		MatSnackBarModule,
		MatSidenavModule,
		MatStepperModule,
		MatAutocompleteModule,
		MatTabsModule,
		MatDividerModule,
		MatListModule,
		MatAutocompleteModule,
		MatFormFieldModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatMomentDateModule,
		MatTreeModule,
	],
})
export class CustomMaterialModule {}
